import { render, staticRenderFns } from "./epro-add-another.vue?vue&type=template&id=2f65a3f8&scoped=true&"
import script from "./epro-add-another.vue?vue&type=script&lang=js&"
export * from "./epro-add-another.vue?vue&type=script&lang=js&"
import style0 from "./epro-add-another.vue?vue&type=style&index=0&id=2f65a3f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65a3f8",
  null
  
)

component.options.__file = "epro-add-another.vue"
export default component.exports